import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
  Typography,
  Box,
  TablePagination,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { ArrowDropUp, ArrowDropDown } from "@mui/icons-material";

import { useFetchTableData } from "../Hook/useFetchTableData";
import styles from "./DataTable.module.scss";

const NewDataTable = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortColumn, setSortColumn] = useState("stunum");
  const [sortDirection, setSortDirection] = useState("DESC");

  const { data, isLoading, isError } = useFetchTableData({
    tableId: "a1d747b4-88d3-4947-8b21-8e99f0039139",
    page: page + 1,
    size: rowsPerPage,
    column: sortColumn,
    direction: sortDirection,
  });

  const columns = data?.columns || [];
  const rows = data?.rows || [];
  const totalRecords = data?.totalRecords || 0;

  return (
    <Paper>
      <TableContainer>
        {isLoading ? (
          <CircularProgress sx={{ m: 4 }} />
        ) : isError ? (
          <Typography color="error" sx={{ m: 2 }}>
            Error fetching data
          </Typography>
        ) : (
          <Table>
            <TableHead>
              <TableRow className={styles.tableHead}>
                {/* First column for error status with red circle */}
                <TableCell>Error</TableCell>
                {columns.map((col) => {
                  const isSorted = sortColumn === col.columnName;
                  const isAsc = sortDirection === "ASC";

                  return (
                    <TableCell
                      key={col.columnId}
                      className={styles.tableTH}
                      onClick={() => {
                        if (isSorted) {
                          setSortDirection(isAsc ? "DESC" : "ASC");
                        } else {
                          setSortColumn(col.columnName);
                          setSortDirection("ASC");
                        }
                        setPage(0);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <span>{col.columnName}</span>
                        <Box
                          display="flex"
                          flexDirection="column"
                          ml={1}
                          className={styles.sortIcons}
                        >
                          <ArrowDropUp
                            className={
                              isSorted && isAsc
                                ? styles.activeSort
                                : styles.inactiveSort
                            }
                          />
                          <ArrowDropDown
                            className={
                              isSorted && !isAsc
                                ? styles.activeSort
                                : styles.inactiveSort
                            }
                          />
                        </Box>
                      </Box>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row) => (
                <TableRow
                  key={row.rowId}
                  className={`${styles.tableRow} ${
                    row.hasError ? styles.errorRow : ""
                  }`}
                >
                  {/* First column for error indication with red circle */}
                  <TableCell>
                    {row.hasError && (
                      <Box
                        sx={{
                          width: 14,
                          height: 14,
                          borderRadius: "50%",
                          backgroundColor: "red",
                        }}
                      />
                    )}
                  </TableCell>

                  {columns.map((col) => {
                    const cell = row.columnData.find(
                      (c) => c.columnId === col.columnId
                    );
                    return (
                      <TableCell
                        key={col.columnId}
                        className={
                          cell?.hasError ? styles.errorCell : styles.tableTD
                        }
                      >
                        {cell?.rowData ?? ""}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </TableContainer>
      <TablePagination
        className={styles.TablePagination}
        component="div"
        count={totalRecords}
        page={page}
        onPageChange={(_, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setPage(0);
          setRowsPerPage(parseInt(e.target.value, 10));
        }}
        rowsPerPageOptions={[5, 10, 20, 50]}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} of ${count}`
        }
        showFirstButton
        showLastButton
      />
      {/* <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
      >
        <FormControl size="small" sx={{ minWidth: 150 }}>
          <InputLabel>Sort Column</InputLabel>
          <Select
            label="Sort Column"
            value={sortColumn}
            onChange={(e) => {
              setPage(0);
              setSortColumn(e.target.value);
            }}
          >
            {columns.map((col) => (
              <MenuItem key={col.columnId} value={col.columnName}>
                {col.columnName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>Direction</InputLabel>
          <Select
            label="Direction"
            value={sortDirection}
            onChange={(e) => {
              setPage(0);
              setSortDirection(e.target.value);
            }}
          >
            <MenuItem value="ASC">Ascending</MenuItem>
            <MenuItem value="DESC">Descending</MenuItem>
          </Select>
        </FormControl>
      </Box> */}
    </Paper>
  );
};

export default NewDataTable;
